// src/lib/stores/persist.js
import { writable } from 'svelte/store';

export function persist(key, defaultValue) {
    const isBrowser = typeof window !== 'undefined';

    let initialValue = defaultValue;

    if (isBrowser) {
        try {
            const saved = localStorage.getItem(key);
            if (saved !== null) {
                initialValue = JSON.parse(saved);
            }
        } catch (e) {
            console.warn('Persist parse error:', key, e);
        }
    }

    const store = writable(initialValue);

    if (isBrowser) {
        store.subscribe((value) => {
            try {
                localStorage.setItem(key, JSON.stringify(value));
            } catch (e) {
                console.warn('Persist save error:', key, e);
            }
        });
    }

    return store;
}

/*
export function persist(key, defaultValue) {
    const isObject = typeof defaultValue === 'object' && defaultValue !== null;

    let initialValue = defaultValue;

    if (typeof window !== 'undefined') {
        try {
            const saved = localStorage.getItem(key);
            if (saved !== null) {
                if (isObject) {
                    initialValue = { ...defaultValue, ...JSON.parse(saved) };
                } else {
                    initialValue = saved;
                }
            }
        } catch { }
    }

    const store = writable(initialValue);

    store.subscribe((value) => {
        try {
            localStorage.setItem(
                key,
                isObject ? JSON.stringify(value) : value
            );
        } catch { }
    });

    return store;
}
*/

/*
export const selectedFace = persist('selectedFace', 'info');
$selectedFace = 'cam';
export const appState = persist('appState', {
    selectedFace: 'info',
    theme: 'light',
    lang: 'vi'
});
$appState.selectedFace = 'cam';
$appState.lang = 'en';
*/

/**
 * Face store (UI state)
 */
function createFaceStore() {
    const face = persist('$selectedFace', 'info');
    const menuVisible = writable(true);

    function changeFace(next) {
        face.set(next);

        // logic tổng quát cho hide / show
        if (next === 'cam') {
            menuVisible.set(false);
        } else {
            menuVisible.set(true);
        }

        window.dispatchEvent(
            new CustomEvent('close-spotlight')
        );
    }

    function showMenu() {
        menuVisible.set(true);
    }

    function hideMenu() {
        menuVisible.set(false);
    }

    function toggleMenu() {
        menuVisible.update((v) => !v);
    }

    // ===== RIGHT PANEL (NEW) =====
    const rightVisible = persist('ui:right-visible', true);

    function showRight() {
        rightVisible.set(true);
    }

    function hideRight() {
        rightVisible.set(false);
    }

    function toggleRight(force) {
        if (typeof force === 'boolean') {
            rightVisible.set(force);
        } else {
            rightVisible.update((v) => !v);
        }
    }

    return {
        face,
        menuVisible,
        changeFace,
        showMenu,
        hideMenu,
        toggleMenu,
        rightVisible,
        toggleRight,
        showRight,
        hideRight
    };
}

export const faceStore = createFaceStore();